export const IS_LOADING = "@@stopWordsAction/IS_LOADING";
export const GET_STOP_WORDS_LIST = "@@stopWordsAction/GET_STOP_WORDS_LIST";
export const ON_FAILURE = "@@stopWordsAction/ON_FAILURE_GET_LIST";
export const CLEAR_SNACKBAR_MESSAGE = "@@stopWordsAction/CLEAR_SNACKBAR_MESSAGE";
export const ADD_STOP_WORD = "@@stopWordsAction/ADD_STOP_WORD";
export const UPDATE_STOP_WORD = "@@stopWordsAction/UPDATE_STOP_WORD";
export const DELETE_STOP_WORD = "@@stopWordsAction/DELETE_STOP_WORD";
export const UPDATE_STOP_WORD_SEARCH_QUERY = "@@stopWordsAction/UPDATE_STOP_WORD_SEARCH_QUERY";
export const UPDATE_STOP_WORD_SEARCH_ERROR = "@@stopWordsAction/UPDATE_STOP_WORD_SEARCH_ERROR";